import { useCallback, useEffect, useState } from "react";
import { listMyLinks } from "@/features/identity/api/linksApi";
import { friendlyDataError } from "@/lib/errors";

export function useMyLinks() {
  const [state, setState] = useState({ status: "loading", links: [], error: null });

  const load = useCallback(async () => {
    setState((s) => ({ ...s, status: "loading", error: null }));
    try {
      setState({ status: "ready", links: await listMyLinks(), error: null });
    } catch (err) {
      setState({ status: "error", links: [], error: friendlyDataError(err, "We couldn't load your links.") });
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  return { ...state, reload: load };
}
